module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-banner-home"
  }, [_c('video', {
    attrs: {
      "src": "https://lakenonaorthodontics.com/wp-content/uploads/Sakowitz-Smiles-Web-Banner.mp4",
      "type": "video/mp4",
      "playsinline": "playsinline",
      "autoplay": "autoplay",
      "muted": "muted",
      "loop": "loop"
    },
    domProps: {
      "muted": true
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b02f4140","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero/hero-home/hero-home.pug
// module id = 606
// module chunks = 1